<template>
  <div class="tab_box">
    <Form :model="formData" inline>
      <FormItem label="状态" prop="invoice_status">
        <Select v-model="formData.invoice_status" @on-change="selectChange">
          <Option value="4">全部</Option>
          <Option value="2">已开发票</Option>
          <Option value="3">未开发票</Option>
          <Option value="1">发票申请中</Option>
        </Select>
      </FormItem>
      <FormItem label="开始时间" prop="pay_startTime">
        <DatePicker
          type="date"
          placeholder="起始"
          v-model="formData.pay_startTime"
          :editable="false"
        ></DatePicker>
      </FormItem>
      <FormItem label="结束时间" prop="pay_endTime">
        <DatePicker
          type="date"
          placeholder="结束"
          v-model="formData.pay_endTime"
          :editable="false"
        ></DatePicker>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="getOrderInfo">查询</Button>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="getInvoice">开具发票</Button>
      </FormItem>
    </Form>

    <Tabs value="incomplete" :animated="false" class="record-warper">
      <!-- 未完成 -->
      <TabPane label="未完成" name="incomplete" class="incomplete">
        <div class="item" v-for="item in incompleteData" :key="item._id">
          <p>订单号: {{ item.orderid }}</p>
          <p>日期: {{ item.place_order_date }}</p>
          <p>金额: {{ item.money }}</p>
          <p>支付方式: {{ item.dec }}</p>
          <p>在线数: {{ item.many }}</p>
          <p>套餐类型: {{ item.type }}</p>
          <p>有无使用优惠劵: {{ item.code ? "是" : "否" }}</p>
          <Button class="goPay" type="primary" ghost @click="goPay(item)"
            >立即支付</Button
          >
          <Button class="goCancel" type="primary" ghost @click="goCancel(item)"
            >取消订单</Button
          >
        </div>
        <div v-if="this.incompleteData.length == 0">
          <p class="noTitle">没有数据</p>
        </div>
      </TabPane>

      <!-- 已完成 -->
      <TabPane label="已完成" name="complete">
        <Table
          border
          ref="selection"
          :columns="columnsComplete"
          :data="completeData"
          @on-selection-change="getSelect"
          _disabled
        ></Table>
      </TabPane>

      <!--  过期页-->
      <TabPane label="已过期" name="expire" class="expire">
        <div class="item" v-for="item in expireData" :key="item._id">
          <p>订单号: {{ item.orderid }}</p>
          <p>日期: {{ item.place_order_date }}</p>
          <p>金额: {{ item.money }}</p>
          <p>支付方式: {{ item.dec }}</p>
          <p>在线数: {{ item.many }}</p>
          <p>套餐类型: {{ item.type }}</p>
          <p>有无使用优惠劵: {{ item.code ? "已退回" : "无" }}</p>
          <Button class="goCancel" type="primary" ghost @click="goCancel(item)"
            >取消订单</Button
          >
        </div>
        <div v-if="this.expireData.length == 0">
          <p class="noTitle">没有数据</p>
        </div>
      </TabPane>
    </Tabs>
    <div v-if="payModal">
      <Modal
        :title="modalTitle + '二维码扫一扫'"
        v-model="payModal"
        @on-cancel="canel"
        class-name="vertical-center-modal"
      >
        <img :src="qCodeSrc" width="310" height="310" />
        <p>付款成功后，本窗口将自动关闭，请勿手动关闭</p>
        <div slot="footer"></div>
      </Modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import doPost from "@/pages/Helper/XHR.js";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      completeData: [], //完成页得数据
      columnsComplete: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "订单编号",
          key: "orderid",
          align: "center",
          minWidth: 180
        },
        {
          title: "时间",
          key: "place_order_date",
          align: "center",
          minWidth: 180
        },
        {
          title: "套餐类型",
          key: "type",
          align: "center",
          minWidth: 100
        },
        {
          title: "在线数",
          key: "many",
          align: "center",
          minWidth: 80
        },
        {
          title: "支付方式",
          key: "pay_method",
          align: "center",
          minWidth: 100
        },
        {
          title: "金额",
          key: "money",
          align: "center",
          minWidth: 80
        }
      ],
      formData: {
        invoice_status: "4", //发票状态
        pay_startTime: "", //开始时间
        pay_endTime: "" //结束时间
      }, //表单元素
      selectData: [],
      orderid_Str: "", //多选多个订单号,英文逗号','拼接成的字符串
      invoice_money: "", //多个订单或单个订单的总金额(元)
      orderArray: [], //勾选的订单组成的数组

      incompleteData: [], //未完成页的数据
      expireData: [], //过期页的数据
      payModal: false, // 支付弹框
      modalTitle: "",
      qCodeSrc: "",
      timer: null
    };
  },
  created() {
    this.getCurrentMonthFirstDay();
    this.getOrderInfo();
  },
  methods: {
    //获取当前的日期以及当前月份的第一天 设置到上面
    getCurrentMonthFirstDay() {
      // 获取当月的第一天
      var date = new Date();
      date.setDate(1);
      var month = parseInt(date.getMonth() + 1);
      var day = date.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      this.formData.pay_startTime =
        date.getFullYear() + "-" + month + "-" + day;
      this.formData.pay_endTime = new Date();
    },
    // 日期传参之前的处理格式处理
    formatDate(val) {
      let date = new Date(val);
      let month = parseInt(date.getMonth() + 1);
      let day = date.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      return date.getFullYear() + "-" + month + "-" + day;
    },
    //获取/查询订单信息---先对日期格式进行处理
    getOrderInfo() {
      if (this.selectData) {
        this.selectData = [];
      }
      doPost(
        {
          action: "order_Manage",
          session_str: localStorage.getItem("session_str"),
          invoice_status: this.formData.invoice_status,
          pay_startTime: this.formData.pay_startTime
            ? this.formatDate(this.formData.pay_startTime)
            : "",
          pay_endTime: this.formData.pay_endTime
            ? this.formatDate(this.formData.pay_endTime)
            : ""
        },
        res => {
          // if(!res.status){
          //     console.log('====='+JSON.stringify(res));
          //     if(res.list!=false){
          //        this.orderData=res.list;
          //        this.orderData.forEach((item,index)=>{
          //            if(item.invoice_status=='1'||item.invoice_status=='2'){
          //                item['_disabled']=true;
          //            }
          //        })
          //     }
          // }else{
          //     if (res.detail == "权限验证失败") {
          //         this.$Message.warning("登录已过期，即将重新登陆");
          //         setTimeout(()=>{
          //             this.$emit('loginout');
          //         }, 1500);
          //     }
          // }

          //2020-10-20 修改逻辑
          if (!res.status && !res.ilst) {
            //先初始话三页的数据
            this.completeData = [];
            this.incompleteData = [];
            this.expireData = [];

            res.list.forEach((item, index) => {
              if (item.past == "已过期") {
                this.expireData.unshift(item);
              } else if (item.is_pay == "1" && item.past == "未过期") {
                this.incompleteData.unshift(item);
              } else if (item.is_pay == "2" && item.past == "未过期") {
                this.completeData.unshift(item);
              }
            });

            //2020-11-2 数据加载完后滚动条滑动到顶部
            document.querySelector(".ivu-tabs-content").scrollTo({
              top: 0,
              behavior: "smooth"
            });

            // console.log('\nincompleteData==='+JSON.stringify(this.incompleteData)+'\n'+'数据长度==='+this.incompleteData.length)
            // console.log('\ncompleteData==='+JSON.stringify(this.completeData)+'\n'+'数据长度==='+this.completeData.length)
            // console.log('\nexpireData==='+JSON.stringify(this.expireData)+'\n'+'数据长度==='+this.expireData.length)
          } else {
            if (res.detail == "权限验证失败") {
              this.$Message.warning("登录已过期，即将重新登陆");
              setTimeout(() => {
                this.$emit("loginout");
              }, 1500);
            }
          }
        }
      );
    },
    //获取订单勾选项
    getSelect(all, current) {
      this.selectData = all;
      // console.log(this.selectData);
    },
    //开发票
    getInvoice() {
      if (this.selectData.length == 0) {
        this.$Message.warning("请先选择订单");
        return;
      }
      //开发票前   记住勾选了哪些订单 以及订单的总金额
      this.invoice_money = 0;
      this.selectData.forEach(item => {
        this.orderArray.push(item["orderid"]);
        this.invoice_money += Number(item["money"]);
      });
      if (!this.invoice_money) {
        this.$Message.error("兑换码购买的套餐不能开具发票");
        return;
      }
      // if(this.invoice_money<=99){
      //     this.$Message.error('开具发票金额应大于99元');
      //     return
      // }

      this.orderid_Str = this.orderArray.join(",");
      // console.log(this.orderid_Str)
      localStorage.setItem("orderid_Str", this.orderid_Str);
      localStorage.setItem("invoice_money", this.invoice_money);
      // this.$router.push('/Personal/invoice')
      this.$emit("gorecharge", "1");
    },

    //状态选择更换后会发起请求
    selectChange() {
      this.getOrderInfo();
    },

    //立即支付
    goPay(item) {
      console.log("订单信息", item);
      var isMoblie = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(
        navigator.userAgent
      );
      console.log("item====" + JSON.stringify(item));
      this.$store.commit("changOrderId", item.orderid);
      if (
        (item.dev == "android" || item.dev == "ios") &&
        item.dec == "微信支付"
      ) {
        this.$Message.error("支付失败，当前微信订单只能到移动客户端付");
        return;
      }
      // console.log('===='+JSON.stringify(item));  isMoblie ? 'dnf' : 'pc'
      // 移动端微信支付
      if (item.pay_method == "weixin" && isMoblie) {
        let formData = new FormData();
        formData.append("action", "pay");
        formData.append("id", item.orderid);
        axios({
          method: "post",
          url: "/h5.php",
          type: "POST",
          dataType: "json",
          data: formData
        }).then(res => {
          if (res.data.status == 1) {
            this.$Message.error(res.data.detail, 1);
            return;
          }
          if (res.status == 200 && res.data.mweb_url) {
            window.location.href = res.data.mweb_url;
          } else {
            if (res.data.err_code_des == "201 商户订单号重复") {
              this.$Message.warning("支付失败，请前往套餐购买页重新购买");
              return;
            }
          }
        });
        return;
      }
      doPost(
        {
          action: "pay",
          orderid: item.orderid,
          int: "",
          dev: isMoblie ? "dnf" : "pc"
        },
        res => {
          if (res.status == 1) {
            this.$Message.error(res.detail);
            return;
          }
          // (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))
          if (
            isMoblie &&
            (item.pay_method == "alipay" || item.pay_method == "alipay_new")
          ) {
            //  return
            //支付宝直接返回form表单
            document.write(res);
            return;
          } else {
            //显示微信页面 并动态填充数据
            let code_url = res.code_url;
            if (code_url) {
              if (!isMoblie && item.dev == "dnf") {
                this.$Message.warning("支付失败，请前往套餐购买页重新购买");
                return;
              }
              // 支付弹框
              this.payModal = true;
              this.modalTitle = item.pay_method == "weixin" ? "微信" : "支付宝";
              this.qCodeSrc = code_url;
              this.payOrderid(res.orderid);
              return;
              this.$router.push({
                name: "payment",
                params: {
                  orderid: res.orderid,
                  code_url: code_url,
                  money: res.money,
                  payMethod: item.pay_method
                }
              });
            }
            return;
          }
        }
      );
    },

    //取消订单
    goCancel(item) {
      // console.log('===='+item);
      let username = Cookies.get("username");
      let session = localStorage.getItem("session_str");
      doPost(
        {
          action: "cancelorder",
          orderid: item.orderid,
          session_str: session,
          web: "pc"
        },
        res => {
          if (!res.status) {
            this.$Message.success(res.detail);
            this.getOrderInfo();
          } else {
            this.$Message.success(res.detail);
          }
        }
      );
    },
    canel() {
      this.payModal = false;
      clearInterval(this.timer);
      this.timer = null;
    },
    // 心跳--查询支付状态
    payOrderid(orderid) {
      if (orderid) {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
        this.timer = setInterval(() => {
          doPost({ action: "orderquery", orderid: orderid }, res => {
            if (res.detail == "支付成功" && res.status == 0) {
              this.payModal = false;
              clearInterval(this.timer);
              this.timer = null;
              this.$Message.success("您已支付成功");
            } else {
              if (res.detail == "支付失败" && res.status == 1) {
                this.payOrderid(orderid);
              }
            }
          });
        }, 1500);
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
>>>.ivu-modal-body
    text-align center
>>>.ivu-modal-header-inner
    text-align center
>>>.ivu-modal-footer
    border-top none
>>>.vertical-center-modal
    display flex
    align-items center
    justify-content center
    .ivu-modal
        top 0
.tab_box
    width 100%
    overflow hidden
.record-warper
    // 2020-12-3 注释
    // height 365px
>>>.ivu-tabs-content
  height: 315px
  width: 100%
  overflow: auto

.tab_box >>>.ivu-form-item-content
    float left

.incomplete .item, .expire .item
    padding: 10px;
    line-height: 22px;
    position: relative;
    margin: 15px auto;
    border: 1px solid #dcdee2;
.incomplete .item >>>.ivu-btn-primary.goPay
    position: absolute;
    right: 50px;
    top: 20px;
    border-radius: 15px;
    color: #3edcab;
    border-color: #3edcab;
.incomplete .item >>>.ivu-btn-primary.goCancel, .expire .item >>>.ivu-btn-primary.goCancel
    position: absolute;
    right: 50px;
    top: 70px;
    border-radius: 15px;
    color: #999;
    border-color: #999;
.noTitle
    text-align: center
@media screen and (max-width: 800px)
    >>>.ivu-tabs-content
        height:150px
    .incomplete .item >>>.ivu-btn-primary.goPay
        right:10px
        top:33px

    .incomplete .item >>>.ivu-btn-primary.goCancel, .expire .item >>>.ivu-btn-primary.goCancel
        right:10px
        top:80px
</style>



// WEBPACK FOOTER //
// src/pages/Personal/components/recharge.vue